import styled from "@emotion/styled";
import {
  AppBar,
  Button,
  Container,
  Grid,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
} from "@mui/material";
import * as React from "react";
import { Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import {
  getLoggedInUser,
  logout,
} from "../../redux/actions/AdminAction";

const NavLinkButton = styled(Button)(({ theme }) => ({
  textDecoration: "none",
  color: "white",
  padding: 10,
  fontFamily: ["Roboto", "sans-serif"].join(","),
  fontOpticalSizing: "auto",
  fontWeight: 400,
  fontStyle: "normal",
}));

export default function AdminHeader() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [anchorElCustomer, setAnchorElCustomer] = React.useState(null);
  const openCustomer = Boolean(anchorElCustomer);

  const [anchorElHXKiller, setAnchorElHXKiller] = React.useState(null);
  const openHXKiller = Boolean(anchorElHXKiller);

  const [anchorElHXPreventer, setAnchorElHXPreventer] = React.useState(null);
  const openHXPreventer = Boolean(anchorElHXPreventer);

  const GetLoggedInUser = useSelector((state) => state.GetLoggedInUser);
  const { loggedInUserInfo } = GetLoggedInUser;

  const token = JSON.parse(localStorage.getItem("userInfo"));
  const user_id = JSON.parse(localStorage.getItem("user_id"));

  React.useEffect(() => {
    if (token) {
      dispatch(getLoggedInUser(user_id));
    }
  }, [token]);

  return (
    <Fragment>
      <AppBar
        elevation={0}
        position="static"
        sx={{ backgroundColor: "#282828" }}
      >
        <Container>
          <Toolbar>
            <Grid
              xs={4}
              sx={{
                display: "flex",
                textAlign: "center",
                width: "100%",
              }}
            >
              <Typography variant="h4">
                <NavLink
                  to="/home"
                  style={{
                    color: "#ffffff",
                    textDecoration: "none",
                  }}
                >
                  Gtech Distribution Private Limited
                </NavLink>
              </Typography>
            </Grid>
            <Grid
              item
              spacing={2}
              xs={6}
              sx={{
                textAlign: "right",
                width: "100%",
                fontSize: 18,
              }}
            >
              {/* {token && (
                <>
                  <NavLinkButton>Profile</NavLinkButton>
                  <NavLinkButton
                    onClick={
                      (event) => setAnchorElCustomer(event.currentTarget)
                      // navigate("/managecustomer")
                    }
                    aria-controls={openCustomer ? "basic-menu" : undefined}
                    aria-expanded={openCustomer ? "true" : undefined}
                  >
                    Customer
                  </NavLinkButton>
                  <Menu
                    sx={{ mt: 1.2 }}
                    anchorEl={anchorElCustomer}
                    open={openCustomer}
                    onClose={() => setAnchorElCustomer(null)}
                    MenuListProps={{
                      "aria-labelledby": "basic-button",
                    }}
                  >
                    <MenuItem
                      onClick={() => {
                        navigate("/managecustomer");
                        setAnchorElCustomer(null);
                      }}
                    >
                      Manage Customer
                    </MenuItem>
                  </Menu>
                  <NavLinkButton
                    onClick={
                      (event) => setAnchorElHXKiller(event.currentTarget)
                      // navigate("/hxCancellationRules")
                    }
                    aria-controls={openHXKiller ? "basic-menu" : undefined}
                    aria-expanded={openHXKiller ? "true" : undefined}
                  >
                    HX Killer
                  </NavLinkButton>
                  <Menu
                    sx={{ mt: 1.2 }}
                    anchorEl={anchorElHXKiller}
                    open={openHXKiller}
                    onClose={() => setAnchorElHXKiller(null)}
                    MenuListProps={{
                      "aria-labelledby": "basic-button",
                    }}
                  >
                    <MenuItem
                      onClick={() => {
                        navigate("/hxCancellationRules");
                        setAnchorElHXKiller(null);
                      }}
                    >
                      Cancellation Rule
                    </MenuItem>
                    <MenuItem>Email Rules</MenuItem>
                    <MenuItem>SMTP Settings</MenuItem>
                  </Menu>
                  <NavLinkButton
                    onClick={(event) =>
                      setAnchorElHXPreventer(event.currentTarget)
                    }
                    aria-controls={openHXPreventer ? "basic-menu" : undefined}
                    aria-expanded={openHXPreventer ? "true" : undefined}
                  >
                    HX Preventer
                  </NavLinkButton>
                  <Menu
                    sx={{ mt: 1.2 }}
                    anchorEl={anchorElHXPreventer}
                    open={openHXPreventer}
                    onClose={() => setAnchorElHXPreventer(null)}
                    MenuListProps={{
                      "aria-labelledby": "basic-button",
                    }}
                  >
                    <MenuItem>Prevention Rules</MenuItem>
                    <MenuItem>Email Rules</MenuItem>
                    <MenuItem>SMTP Settings</MenuItem>
                    <MenuItem>City Timezone Mappings</MenuItem>
                    <MenuItem>Vendor Remark Formats</MenuItem>
                  </Menu>
                  <NavLinkButton onClick={() => dispatch(logout())}>
                    LOGOUT
                  </NavLinkButton>
                </>
              )} */}
              {loggedInUserInfo &&
                (loggedInUserInfo?.first_name || "") +
                  (loggedInUserInfo?.last_name || "")}
              {token && (
                <NavLinkButton onClick={() => dispatch(logout())}>
                  LOGOUT
                </NavLinkButton>
              )}
            </Grid>
          </Toolbar>
        </Container>
      </AppBar>
    </Fragment>
  );
}
